var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length)?_c('ul',{staticClass:"list-errors"},_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_c('small',[_c('i',{staticClass:"far fa-fw fa-times"}),_vm._v(_vm._s(error))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }